module.exports={
  "borough": {
    "bronx": {
      "new-stadium": "Yes, I will do whatever I can to make this happen",
      "if-free": "Yes, but only if a deal can be reached with no public subsidy or tax breaks",
      "no-stadium": "No"
    },
    "brooklyn": {
      "yes-pipeline": "Yes",
      "review-route": "Yes, but the proposed route requires more review",
      "no-pipeline": "No"
    },
    "manhattan": {
      "yes-comm-rent-control": "Yes — I’m ready to work toward implementing a system",
      "study-model": "Let’s study the issue and see if any model could possibly succeed in Manhattan",
      "no-comm-rent-control": "No, commercial rent control does not work"
    },
    "queens": {
      "yes-yard": "Yes, as planned",
      "review-yard": "Yes, but the project’s cost, scale, community input or other fundamentals need revisiting",
      "no-yard": "No"
    },
    "staten-island": {
      "restore-now": "Yes, immediately after taking office",
      "restore-soon": "Yes, within my first term",
      "no-ferry": "No"
    }
  },
  "building-nyc": {
    "broadband": {
      "public-internet": "Create a publicly owned and operated municipal broadband network",
      "low-cost-internet": "Build on the existing city plan inviting companies to build out low-cost service",
      "subsidy-enough": "New state law requiring $15/month broadband for low-income customers is sufficient"
    },
    "elevator": {
      "mta-maintenance": "Yes, with the MTA maintaining the elevators",
      "commit-maintenance": "Yes, only if the developer also commits to providing ongoing maintenance",
      "no-private-elevator": "No"
    },
    "landuse-review": {
      "require-review": "Yes, require additional review",
      "maintain-review": "Stick with existing procedures and customs",
      "lower-review": "The process needs fewer obstacles to development"
    },
    "sidewalk-shed": {
      "repair-asap": "Champion, sign and enforce a City Council bill that would require property owners to complete facade repairs within 90 days",
      "review-rules": "Review existing building codes and enforcement to ensure the Department of Buildings doesn’t go overboard in requiring sheds",
      "focus-current": "Focus on managing the current facade inspection and repair system"
    }
  },
  "climate-change": {
    "energy-targets": {
      "finance-upgrades": "Help owners finance upgrades",
      "cap-and-trade": "Institute a cap-and-trade program that lets owners buy credits to offset their emissions",
      "revise-law": "Revise the law’s timeline or penalties",
      "no-action": "None — Local Law 97 is solid as is"
    },
    "flood-zones": {
      "stop-building": "Limit new development and enable owners to sell properties to the city",
      "elevate-homes": "Invest in elevating and fortifying homes and other buildings",
      "build-seawalls": "Construct protective infrastructure such as seawalls and restore wetlands",
      "no-new-action": "No new action"
    },
    "gas": {
      "ban-hookup": "Yes",
      "phase-out-gas": "Yes, and move the goal sooner and/or make strides to phase out fossil fuels in existing buildings",
      "allow-hookup": "No"
    },
    "organic-waste": {
      "maintain-ow": "Maintain the program as is",
      "optional-ow": "Expand organic waste collection to all New Yorkers, but keep it optional",
      "mandatory-ow": "Expand organic waste collection to all New Yorkers and make it mandatory",
      "no-ow": "Get rid of the program"
    }
  },
  "corona-recovery": {
    "mandatory-vac": {
      "yes-mandatory": "Yes",
      "some-yes": "Yes, for health, education, law enforcement and other workers interacting with the public",
      "no-mandate": "No"
    },
    "open-street": {
      "ban-cars": "Yes, ban vehicular access to current open streets",
      "expand": "Yes, and expand the program to include more streets",
      "no-open-street": "No"
    },
    "relief": {
      "ongoing": "Yes, ongoing aid for the needy",
      "one-time": "Yes, one-time assistance",
      "no-relief": "No"
    },
    "reopening": {
      "quick": "Schools have reopened for in-person/hybrid learning too quickly",
      "slow": "Schools have reopened for in-person/hybrid learning too slowly",
      "appropriate": "Schools have reopened at an appropriate pace"
    }
  },
  "criminal-justice": {
    "drug": {
      "pot-only": "Marijuana only",
      "pot-more": "Marijuana and one or more other drugs",
      "arrest": "No"
    },
    "rikers": {
      "as-proposed": "Yes, build all new planned smaller borough-based jails on the current timeline",
      "change-timeline": "Yes, build new smaller borough-based jails but consider changes to plans or timeline",
      "reevaluate": "Reevaluate closing Rikers",
      "close-all": "Close Rikers, but build no new jails"
    },
    "solitary": {
      "ban-entirely": "Ban solitary confinement entirely",
      "maintain-hours": "Maintain current plan to allow minimum 10 hours per day out of cells",
      "no-ban": "No"
    },
    "trial": {
      "supervised": "Promote use of city supervised release programs for more people",
      "release": "Promote release without supervision programs for more people",
      "jail": "Promote pretrial jail for more people who currently must be released",
      "no-change": "Leave the current system as is"
    }
  },
  "education": {
    "admissions-district": {
      "yes-limit": "Yes",
      "set-asides": "Allow applicants outside the district, through set-asides or other means",
      "no-admissions": "No"
    },
    "charter": {
      "more": "Yes, advocate for more charter schools",
      "no-discourage": "No, discourage more charter schools",
      "stricter": "Advocate for more charter schools under stricter conditions than currently apply"
    },
    "raise-money": {
      "yes": "Yes, keep fundraising as is",
      "redistribute": "Yes, but a system is needed to share funds between schools with many wealthy families and those with many poor families",
      "no-limits": "No. Limits or further ground rules are needed for fundraising"
    },
    "shsat": {
      "keep": "Yes, keep the SHSAT",
      "mixed-measures": "Keep the SHSAT but also require additional admissions measures",
      "abolish": "No, abolish the SHSAT"
    }
  },
  "homelessness": {
    "30thstreet": {
      "close-shelter": "Yes, completely close within the next mayor’s term(s)",
      "reserve-shelter": "Close but keep ready and available to handle surges in demand",
      "keep-shelter": "Keep the 30th Street shelter open as is"
    },
    "hotel": {
      "yes-hotel": "Yes, hotel capacity is needed for temporary or permanent housing",
      "phase-out-hotel": "Keep current city plan to phase out hotels for the homeless by 2023",
      "end-hotel": "No, end homeless hotels as soon as possible"
    },
    "nypd-response": {
      "yes-nypd-response": "Yes, generally",
      "specifically": "Yes, specifically when public safety risks arise",
      "no-nypd-response": "No, NYPD should not be involved in homeless response"
    },
    "right-to-shelter": {
      "renegotiate": "Renegotiate “right to shelter” into a “right to housing” to invest in permanent solutions",
      "lower-barriers": "Keep “right to shelter” but lower existing barriers to families seeking shelter",
      "keep-right": "Keep “right to shelter” as already agreed to"
    }
  },
  "housing": {
    "affordable": {
      "range": "Focus city funding on development projects that mix affordability at a range of incomes, using rents paid by higher earners to help cover costs for the lowest-income tenants",
      "low-income": "Focus city funding on 100% affordable development projects for the lowest-income tenants, even if that may create fewer units overall",
      "scale-back": "Scale back city subsidies to affordable housing development, focusing resources on helping renters pay for existing housing"
    },
    "battery-park-city": {
      "upgrade": "Yes, NYCHA needs a dedicated revenue stream to pay for much-needed apartment upgrades",
      "split": "Yes, but split the money between NYCHA and other affordable housing programs",
      "general": "No, 100% of this money should continue to be dedicated to general affordable housing programs"
    },
    "rad": {
      "yes-rad": "Yes, this is the best way for NYCHA to upgrade its deteriorating apartments",
      "maintain-oversight": "Yes, but keep a substantial number of apartments out of RAD to maintain oversight of those apartments by the monitor",
      "private": "No, NYCHA should not rely on private firms to manage its buildings"
    },
    "upzone": {
      "areawide": "Yes, as part of area-wide rezonings",
      "some-yes": "Yes, for specific blocks or properties",
      "no-upzone": "No, the city is already overbuilt"
    }
  },
  "immigration": {
    "attorney": {
      "yes-counsel": "Yes, immigrant New Yorkers facing deportation should have a right to counsel",
      "continue-counsel": "Continue existing city funding sponsoring legal services for immigrant New Yorkers held in detention",
      "no-counsel": "No"
    },
    "basement": {
      "convert-illegal": "Yes, revise building codes to allow current illegal apartments to be compliant",
      "allow-more": "Yes, revise building codes and encourage conversions through financing, counseling or other means",
      "no-basement": "No"
    },
    "cash": {
      "yes-cash": "Yes",
      "special-cash": "Yes — special pandemic assistance only",
      "no-cash": "No"
    },
    "elections": {
      "allow-some": "Yes, permanent residents (green card holders) only",
      "allow-all": "Yes, all New Yorkers, regardless of their immigration status, should be allowed to vote",
      "no-voting": "No"
    }
  },
  "labor": {
    "federal-aid": {
      "wage-subsidies": "Wage subsidies to help employers bring back and retain their employees",
      "extend-ui": "Extended unemployment benefits to all impacted people",
      "more-loans": "Access to loans for entrepreneurs and worker cooperatives",
      "gov-jobs": "Government jobs in underserved communities to rebuild local economies"
    },
    "gig": {
      "reclassify": "Yes, require companies to classify workers as their employees",
      "flex-reclassify": "Yes, give workers flexibility to decide whether they are classified as employees or independent contractors",
      "no-reclassify": "No"
    },
    "unions": {
      "municipal-second": "The mayor is working for voters and taxpayers, who must come first in bargaining with city employees",
      "municipal-first": "Municipal employees keep the city running and the mayor should put their needs first",
      "balance": "Mayors should strive to find a balance between taxpayers and workers, even when that leaves everyone unhappy"
    },
    "wage": {
      "auto-increase": "Yes, and be indexed to inflation so the wage automatically rises each year",
      "review-increase": "Yes, but not indexed to inflation — the wage should come under review before future increases",
      "no-increase": "No"
    }
  },
  "leadership": {
    "hiring": {
      "any-position": "Yes, potentially to any type of position",
      "only-advisory": "Yes, only to advisory or other groups without decision-making authority",
      "no-posting": "No"
    },
    "nonprofit": {
      "as-permitted": "Yes, as currently permitted",
      "add-disclosure": "Yes, adding disclosure of the nonprofits’ spending and recipients",
      "no-soliciting": "No"
    },
    "style": {
      "decider": "The decider — centralize decision-making with the mayor and close advisers",
      "delegator": "The delegator — hire top talent to run agencies and rely on their judgment",
      "partner": "The partner — make decisions in coordination with the City Council"
    },
    "veto": {
      "never-veto": "Never — bills should only come to a Council vote following mayoral agreement",
      "veto-rarely": "Only under extraordinary circumstances",
      "veto-often": "As often as necessary"
    }
  },
  "nypd": {
    "defund-nypd": {
      "reduce-budget": "Yes, redirect a substantial share of NYPD operating resources to other city agencies",
      "maintain": "No, maintain police officer headcount at roughly current levels",
      "keep-budget": "No, increase the number of NYPD officers"
    },
    "mentally-ill-response": {
      "yes-sometimes": "Yes, where the call suggests a risk to others’ safety",
      "depends": "Yes, under most or all circumstances",
      "no-never": "No, NYPD officers should not respond to these calls"
    },
    "nypd-disciplining-officers": {
      "maintain-authority": "The commissioner should retain decision-making authority in all cases",
      "depends": "The commissioner should retain decision-making authority in some cases",
      "civilian-ccrb": "Decisions should be made by a newly empowered Civilian Complaint Review Board",
      "mayor": "The mayor should have the final say in all cases"
    },
    "nypd-residency": {
      "yes-all": "Yes, all officers should reside in the five boroughs by the end of the new mayor’s term",
      "yes-new": "Any new NYPD officer must live in the five boroughs but existing officers may live elsewhere until retirement",
      "no-requirement": "NYPD officers should be able to live in any of the counties currently authorized"
    }
  },
  "quality-of-life": {
    "airbnb": {
      "some-operators": "Yes, large-scale professional operators only",
      "all-rentals": "Yes, all illegal rentals",
      "let-airbnb": "No, let Airbnb be"
    },
    "casino": {
      "yes-manhattan": "Yes — including Manhattan",
      "yes-outerboroughs": "Yes — not including Manhattan",
      "no-casino": "No"
    },
    "restroom": {
      "city-maintain": "City should launch effort to deploy and maintain public restrooms",
      "biz-maintain": "No city restroom program, but incentivize business establishments to make their restrooms available to the public",
      "no-restroom": "No"
    },
    "street-vendor": {
      "expand-vendor": "Expand the number of licenses further",
      "keep-vendor": "Keep the number of licenses as set",
      "evaluate-vendor": "Evaluate impact of new vendor licenses on businesses before further action"
    }
  },
  "taxes": {
    "assessments": {
      "tax-more": "Respond without impacting overall tax dollars collected, even if that means some will pay more than before",
      "tax-less": "Respond without increasing anyone’s tax burdens in the process — potentially reducing tax dollars collected",
      "maintain-tax": "Maintain existing property tax assessment system"
    },
    "stock": {
      "stock-tax": "Yes",
      "no-stock-tax": "No"
    },
    "vacancy": {
      "yes-vacancy": "Yes, for all part-time residents (less than 180 days a year)",
      "intl-only": "Yes, for international owners only",
      "no-vacancy": "No"
    },
    "wealthy": {
      "five-million": "Yes, increase the income tax rate for those who earn more than $5 million annually",
      "ten-million": "Yes, increase the income tax rate for those who earn more than $10 million annually",
      "no-wealth": "No additional taxes"
    }
  },
  "transportation": {
    "bike": {
      "expand-far": "NYC needs to expand its bike lane network into underserved areas, even where lanes have met some local resistance",
      "expand-moderate": "Expand bike lanes, while being responsive to local objections in deciding where to put the lanes",
      "alter-remove": "Alter or remove existing lanes where warranted"
    },
    "bqe": {
      "replace": "Replace, building a temporary highway bypass",
      "keep-current": "Maintenance of current highway",
      "demolish": "Demolish and do not rebuild the BQE"
    },
    "congestion-pricing": {
      "current": "Yes, supporting current plan to capture funds for the MTA",
      "city-control": "Yes, while pursuing city control over the revenue",
      "no-congestion-pricing": "No, or further evaluation is needed"
    },
    "ferry": {
      "continue": "Continue or build on current NYC Ferry service and expansion plans while keeping fare at $2.75, providing additional dollars to step up service",
      "alter": "Alter NYC Ferry service or expansion plans while continuing $2.75 fare",
      "raise": "Raise or change NYC Ferry fare to help support existing and expanded service",
      "raise-evaluate": "Raise or change NYC Ferry fare while reevaluating routes and/or service"
    },
    "transit-system": {
      "yes-share": "Yes, while splitting bridge and tunnel toll revenue with LIRR and Metro-North",
      "yes-full": "Yes, provided the city also gains full control of bridge and tunnel toll revenue",
      "no-city-mta": "No"
    }
  }
}